/**
 * A preferência "cartão do painel RECOLHIDO" em `localStorage`
 * (`CHAVE_DO_RECOLHIDO_NO_STORAGE`, `'1'`): quem recolheu quer o botão
 * compacto nas próximas conversas também; expandir apaga. `try/catch` nos
 * dois sentidos (modo anônimo / storage cheio) — mesma receita do
 * `chat-indice-artefatos/preferencia-de-regua.js`.
 */
import { CHAVE_DO_RECOLHIDO_NO_STORAGE, MARCA_DE_RECOLHIDO } from './painel-do-chat.constantes'

export function lerPrefereRecolhido() {
  try {
    return globalThis.localStorage.getItem(CHAVE_DO_RECOLHIDO_NO_STORAGE) === MARCA_DE_RECOLHIDO
  } catch {
    // storage bloqueado: nasce aberto
    return false
  }
}

export function gravarPrefereRecolhido(prefere) {
  try {
    if (prefere) {
      globalThis.localStorage.setItem(CHAVE_DO_RECOLHIDO_NO_STORAGE, MARCA_DE_RECOLHIDO)
      return
    }
    globalThis.localStorage.removeItem(CHAVE_DO_RECOLHIDO_NO_STORAGE)
  } catch {
    // storage cheio/bloqueado: vale só nesta sessão
  }
}
